<template>
  <div class="background">
    <div v-if="!send">
      <v-form v-if="success == 1" ref="form">
        <v-card elevation="2" style="background-color: #ffff" class="ma-8">
          <v-card-title class="d-flex justify-center"
            >Nueva contraseña
          </v-card-title>
          <v-card-text>
            <div class="box-green pa-2" style="color: #6f8b72">
              Cree una nueva contraseña que no utilice en ningún otro sitio.
            </div>
          </v-card-text>
          <v-text-field
            dense
            v-model="values[0]"
            :rules="rules.first"
            label="Contraseña"
            class="ml-4 mr-4"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            outlined
            clearable
          >
          </v-text-field>
          <v-text-field
            dense
            v-model="values[1]"
            :rules="rules.second"
            label="Confirmar contraseña"
            class="ml-4 mr-4"
            :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showConfirm ? 'text' : 'password'"
            @click:append="showConfirm = !showConfirm"
            outlined
            clearable
          >
          </v-text-field>

          <v-btn
            large
            color="primary"
            class=""
            @click="setPassword"
            style="width: 100%"
          >
            Aceptar
          </v-btn>
        </v-card>
      </v-form>
      <div v-else-if="success == 0">
        <v-card elevation="2" style="background-color: #ffff" class="ma-8">
          <v-card-title class="d-flex justify-center"
            >Token Expiro</v-card-title
          >
          <v-card-text>
            <div class="box-red pa-2">
              El token que se genero ya ha expirado, intente de nuevo.
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <div v-if="send">
      <v-card elevation="2" style="background-color: #ffff" class="ma-8">
        <v-card-title class="d-flex justify-center"
          >Cambio de contraseña</v-card-title
        >
        <v-card-text>
          <div class="box-red pa-2">
            Se cambio con exito la contraseña, dirijase a la aplicacion Solena
            MAS e intente inciar sesion.
          </div>
        </v-card-text>
      </v-card>
    </div>
        <!-- copyright -->
    <v-footer class=" text-caption text-center d-flex justify-center"  fixed> D.R. © Solena Ag, Inc. {{new Date().getFullYear()}} </v-footer>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapMutations } from "vuex";
export default {
  data: () => ({
    token: "",
    success: -1,
    values: ["", ""],
    confirmationPassword: "",
    show: false,
    showConfirm: false,
    send: false,
  }),
  watch: {
    values: {
      handler: function (val) {
        val.forEach((element, index) => {
          if (element == null) {
            this.values[index] = "";
          }
        });
      },
      deep: true,
    },
  },
  async beforeMount() {
    this.token = this.$route.query.token;
    let isRegistered = await this.tokenConfirmation(this.token);
    this.success = isRegistered.success;
  },
  methods: {
    ...mapActions("setPassword", ["tokenConfirmation", "setNewPassword"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations(["SET_LOADER"]),
    async setPassword() {
      try {
        if (this.$refs.form.validate()) {
          this.SET_LOADER(true);
          let paylodad = {
            token: this.token,
            password: this.values[1],
          };
          let response = await this.setNewPassword(paylodad);
          if (response.success == 1) {
            this.send = true;
          }
        }
      } catch (error) {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Error al cambiar contraseña",
          timeout: 4000,
        });
      }
      this.SET_LOADER(false);
    },
  },
  computed: {
    rules() {
      const valid =
        (this.values[0] + "").length == (this.values[1] + "").length &&
        (this.values[1] + "").length > 0;
      const validLenght = this.values[0].length >= 8;
      return {
        first: [
          () => validLenght || "Debe de contener por lo menos 8 caracteres",
        ],
        second: [() => valid || "Debe coincidir con la entrada anterior"],
      };
    },
  },
};
</script>

<style scoped>
.box-green {
  background-color: #d4ecdb;
}

.box-red {
  color: #6f8b72;
  background-color: #d4ecdb;
}

.background {
  background: #ffff;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
</style>
